export { default } from "./MailingListsQuery";



// WEBPACK FOOTER //
// ./src/queries/MailingListsQuery/index.ts